import React from 'react';
import { Flex } from '@chakra-ui/react';
import CustomCheckIcon from '../Icons/CustomCheckIcon';

const CustomRadio = ({ isChecked }) => (
  <Flex
    width="24px"
    height="24px"
    minWidth="24px"
    minHeight="24px"
    flexShrink={0}
    borderRadius="full"
    border="1px solid"
    borderColor={isChecked ? 'green.500' : 'gray.300'}
    bg={isChecked ? 'green.500' : '#EAEAEA'}
    align="center"
    justify="center"
    transition="all 0.2s ease"
  >
  {isChecked && <CustomCheckIcon color="white" boxSize={4} />}
  </Flex>

);

export default CustomRadio;
